export const OBTER_CIDADES = 'OBTER_CIDADES';
export const SELECIONAR_CIDADE = 'SELECIONAR_CIDADE';
export const VERIFICAR_DADOS_MOTORISTA = 'VERIFICAR_DADOS_MOTORISTA';
export const GRAVAR_DADOS_MOTORISTA = 'GRAVAR_DADOS_MOTORISTA';
export const LOGIN = 'LOGIN';
export const OBTER_DADOS_MOTORISTA = 'OBTER_DADOS_MOTORISTA';